import React from "react";
import "../css/Footer.css";
import logo from "../images/logo.svg";

// Иконки Bootstrap
import { 
  Twitter, 
  Telegram, 
  Youtube, 
  Github,
  Envelope,
  GeoAlt,
  Phone,
  ArrowUp,
  HeartFill,
  Clock,
  ShieldCheck
} from "react-bootstrap-icons";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="box _footer">
      <div className="container">
        <div className="footer-content">
          {/* Левый блок — информация о проекте */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="Logo" />
              <span>Crypto<span>Hub</span></span>
            </div>
            <p>
              We believe that the future of finance should be open, fair, 
              and accessible to everyone. Join the movement that brings 
              crypto closer to the people.
            </p>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Telegram">
                <Telegram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Youtube">
                <Youtube size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Github">
                <Github size={20} />
              </a>
            </div>
          </div>

          {/* Средний блок — контакты */}
          <div className="footer-contacts">
            <h4>Contact Us</h4>
            <div className="contact-item">
              <Envelope size={18} />
              <span>support@cryptohub.io</span>
            </div>
            <div className="contact-item">
              <GeoAlt size={18} />
              <span>New York, USA</span>
            </div>
            <div className="contact-item">
              <Phone size={18} />
              <span>+1 (800) 223-2230</span>
            </div>
            <div className="contact-item">
              <Clock size={18} />
              <span>24/7 Support Available</span>
            </div>
          </div>

          {/* Правый блок — ссылки */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#main">Main</a></li>
              <li><a href="#info">Instructions</a></li>
              <li><a href="#live">Live</a></li>
              <li><a href="#participate">Participate</a></li>
            </ul>
          </div>

          {/* Правый блок — безопасность */}
          <div className="footer-security">
            <h4>Security</h4>
            <div className="security-item">
              <ShieldCheck size={20} color="#162a6b" />
              <div>
                <strong>SSL Encrypted</strong>
                <p>Your data is protected</p>
              </div>
            </div>
            <div className="security-item">
              <ShieldCheck size={20} color="#162a6b" />
              <div>
                <strong>Audited Smart Contracts</strong>
                <p>Verified by CertiK</p>
              </div>
            </div>
          </div>
        </div>

        {/* Нижняя часть — копирайт */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <span>© 2026 CryptoHub. All rights reserved.</span>
            <span className="footer-made-with">
              Made with <HeartFill size={14} color="#e74c3c" /> for the crypto community
            </span>
          </div>
          <button className="scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
            <ArrowUp size={22} />
          </button>
        </div>
      </div>
    </footer>
  );
};